export * from './lib/pages/registration-order-confirmation/registration-order-confirmation.component';
export * from './lib/registration-feature-order-registration-confirmation.routes';
